import { GET_REPORT_TYPES, GET_REPORT_CONTENT, CLEAR_REPORT_CONTENT  } from '../constants/constants';

const initialSessionState = { reportTypes: [], content: [], totalElements: 0 };

export default (state = initialSessionState, action) => {
    switch(action.type) {
        case GET_REPORT_TYPES:
            return {
                ...state,
                reportTypes: [ ...action.reportTypes ]
            }
        case GET_REPORT_CONTENT:
            return {
                ...state,
                content: [ ...action.content.content ],
                totalElements: action.content.totalElements
            }
        case CLEAR_REPORT_CONTENT:
            return {
                ...state,
                content: [],
                totalElements: 0
            } 
        default: return state;
    }
}

export const getReportTypes = state => state.reportReducer.reportTypes;
export const getReportData = state => state.reportReducer.content;
export const getReportTotalElements = state => state.reportReducer.totalElements;